<style scoped>
/**
table.v-table thead th,
table.v-table tbody td {
  font-size: 11px;
  font-weight: 400;
  height: 20px;
}
**/

.scroll-area {
  position: relative;
  margin: auto;
  border: 0px solid blue;
  width: 100%;
  height: 100%;
  padding-bottom: 70px;
}

.menu-row {
  font-size: 10px;
}

.v-btn {
  font-size: 12px;
  text-transform: capitalize;
}

.aggregate {
  cursor: pointer;
  border-bottom: 1px solid grey;
  z-index: 1000;
}
</style>
<style>
.cursor-pointer {
  cursor: pointer;
}
.selected-row,
.selected-row:hover {
  background-color: #757575 !important;
  color: white;
}
.selectable-chart .v-list__tile {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: inherit;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 12px !important;
  font-weight: 400;
  height: 20px !important;
  margin: 0;
  padding: 0 16px;
  position: relative;
  text-decoration: none;
  -webkit-transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.selectable-chart .v-list__tile__title {
  height: 14px;
  line-height: 14px;
  position: relative;
  text-align: left;
}

.selectable-chart.taybull-table td {
  padding: 10px 24px !important;
}

</style>
<style>
.table-menu .v-list__tile {
  height: 30px;
  font-size: 14px;
  cursor: pointer;
}
</style>

<template>
  <v-container
    fill-heights
    fluid
    bg
    text-xs-left
    pa-0
    class="selectable-chart taybull-table bg"
    ref="tableContainer"
    style="overflow-y: hidden"
  >
    <v-layout
      fill-heights
      row
      wrap
      justify-center
      class="menu-row"
      v-if="chart.dataSource && chart.dataSource.filteredData"
      style="height: 100%"
    >
      <v-flex
        v-if="chart.chartData.displaySearch && chart.chartData.searchFormSchema"
        :class="chart.chartData.searchFormClass"
      >
        <v-form
          id="search-form"
          ref="searchForm"
          @submit.prevent="formSubmit()"
        >
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex
              :key="index"
              :class="item.class"
              v-for="(item, index) in chart.chartData.searchFormSchema"
            >
              <v-textarea
                v-model="item.model"
                :label="item.label"
                placeholder=" "
                outline
                v-if="item.type == 'textarea'"
              ></v-textarea>
              <v-text-field
                v-model="item.model"
                :label="item.label"
                placeholder=" "
                outline
                v-if="item.type == 'input'"
              ></v-text-field>
              <v-select
                v-if="item.type == 'select'"
                :items="item.list"
                :label="item.label"
                item-text="label"
                item-value="value"
                v-model="item.model"
                outline
              ></v-select>
              
              <v-menu
                v-if="item.type == 'date'"
                v-model="item.menu"
                
                transition="scale-transition"
                offset-y
          full-width
          max-width="290px"
          min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :label="item.label"
                    prepend-icon="event"
                    v-model="item.model"
                    v-on="on"
                  ></v-text-field>
                </template>

                <v-date-picker
                  v-model="item.model"
                  no-title
                  @input="item.menu = false"
                ></v-date-picker>
              </v-menu>
              
              <v-layout row v-if="item.type == 'button'">
                <v-btn color="red" class="white--text" v-on:click="reset()">
                  &nbsp; Reset
                </v-btn>
                <v-btn
                  color="blue-grey"
                  class="white--text"
                  ref="submitButton"
                  v-on:click="searchQuery(item)"
                  type="submit"
                >
                  <!-- <v-icon right dark>search</v-icon> -->
                  &nbsp;
                  {{ item.label }}
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
        </v-form>
        <v-flex xs12 lg6>
        
      </v-flex>
      </v-flex>
      <v-flex :class="chart.chartData.tableClass">
        <v-layout
          row
          wrap
          justify-end
          v-if="topButtonMenu && topButtonMenu.length"
        >
          <template v-for="menu in topButtonMenu">
            <v-btn
              v-on:click="callMenuFunction(menu)"
              :key="menu.id"
              dark
              :class="menu.className ? element.className : ''"
              :style="menu.style ? element.style : ''"
              :color="menu.color ? element.color : ''"
              >{{ menu.name }}
            </v-btn>
          </template>
        </v-layout>
        <v-menu
          v-if="mode != 'view'"
          v-model="columnsMenu"
          :close-on-content-click="false"
          :max-width="350"
          :nudge-width="200"
          offset-x
          :z-index="800"
        >
          <template v-slot:activator="{ on }">
            <v-btn color="primary" flat v-on="on"
              >Columns</v-btn
            > 
          </template>
          <v-card>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click="selectAll(chart.subHeaders)"
                >Select All</v-btn
              >
              <v-btn flat @click="deSelectAll(chart.subHeaders)"
                >De Select All</v-btn
              >
              <v-btn
                flat
                @click="
                  columnsMenu = false;
                  chart.loadActiveItem();
                "
                >Save</v-btn
              >
            </v-card-actions>

            <v-card-text style="overflow: auto; overflow-y: true; height: auto">
              <v-flex sm12>
                <draggable :list="chart.subHeaders" class="list-group">
                  <div
                    style="width: 100%"
                    class="list-group-item"
                    v-for="(item, i) in chart.subHeaders"
                    :key="item.id"
                  >
                    <v-menu offset-y v-if="item.selected == true">
                      <template v-slot:activator="{ on }">
                        <v-chip
                          v-on:click="toggleMenu(chart.subHeaders, i)"
                          @input="deSelect(chart.subHeaders, i)"
                          color="primary"
                          dark
                          close
                          class="chip--select-multi"
                          style="float: left"
                        >
                          <v-avatar>
                            <v-btn
                              class="purple"
                              color="primary"
                              v-on="on"
                              style="width: 20px; height: 20px"
                              fab
                              small
                              dark
                            >
                              <v-icon>expand_more</v-icon>
                            </v-btn>
                          </v-avatar>
                          {{
                            item.aggregate && item.aggregate.functionDisplay
                              ? item.aggregate.functionDisplay.replace(
                                  "field",
                                  item.text
                                )
                              : item.text
                          }}
                        </v-chip>
                      </template>
                      <v-list>
                        <v-list-tile
                          v-for="(fnc, index) in chart.parameters.aggregateList
                            .aggregates"
                          :key="index"
                        >
                          <v-list-tile-title
                            v-on:click="aggregate(chart.subHeaders, i, fnc)"
                            >{{ fnc.text }}</v-list-tile-title
                          >
                        </v-list-tile>
                      </v-list>
                    </v-menu>

                    <v-chip
                      v-else
                      class="chip--select-multi"
                      v-on:click="select(chart.subHeaders, i)"
                      >{{ item.text }}</v-chip
                    >
                  </div>
                </draggable>
              </v-flex>
              <!--
          <v-select v-model="chart.parameters.selectedFields.value" item-value="value" item-text="text" :items="chart.dataSource.headers" label="Select fields" multiple chips hint="Select fields to display" persistent-hint v-on:change="chart.changed(chart.parameters.selectedFields)"></v-select>
              -->
            </v-card-text>
          </v-card>
        </v-menu>
        <v-btn
          v-if="chart.parameters.downloadable.value"
          color="blue-grey"
          class="white--text"
          v-on:click="download(chart.dataSource.filteredData)"
        >
          Download CSV
          <v-icon right dark>cloud_download</v-icon>
        </v-btn>
        <v-flex
          pa-2
          class="text-lg-right"
          v-if="chart.dataSource && chart.parameters.searchable.value"
        >
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            @input="uiFilter()" 
            solo
            hide-details
          ></v-text-field>
          <!--<span v-if="chart.dataSource.loading">Updating Table</span>-->
          <!--<span v-else>displaying {{ chart.dataSource.filteredData.length }} rows of {{ chart.dataSource.size }}</span>-->
        </v-flex>
        <v-flex xs12 fill-heights>
          <div class="elevation-0">
            <div>
              <vue-perfect-scrollbar
                class="scroll-area"
                :settings="settings"
                :style="{ height: window.height + 'px', overflow: 'visible' }"
              >
              <!-- :search="chart.parameters.serverSide.value ? false : search" -->
                <!-- :search="search" -->
                <!--  -->
                <v-data-table
                  :headers="computedHeaders"
                  :hide-headers="!chart.parameters.showHeaders.value"
                  :items="filteredData"
                  :pagination.sync="pagination"
                  :total-items="totalItems"
                  :loading="chart.loading"
                  :disable-initial-sort="true"
                  :custom-filter="customFilter"
                  @update:pagination="paginate"
                  @update:input="autoSelect()"
                >
                  <v-progress-linear
                    color="blue"
                    indeterminate
                  ></v-progress-linear>
                  <template slot="items" slot-scope="props">
                    <tr
                      v-bind:class="{
                        'selected-row':
                          props.item && props.item == selectedItem,
                      }"
                      :style="
                        typeof props.item.attr_row_style != 'undefined'
                          ? props.item.attr_row_style
                          : ''
                      "
                    >
                      <template v-for="header in computedHeaders">
                        <td
                          :key="header.value"
                          v-if="header.value"
                          class="tcell"
                          :style="
                            typeof props.item.attr_cell_style != 'undefined'
                              ? props.item.attr_cell_style
                              : ''
                          "
                          :class="
                            typeof props.item.attr_cell_class != 'undefined'
                              ? props.item.attr_cell_class
                              : ''
                          "
                          v-on:click="
                            setSubChart({ chart: chart, item: props.item })
                          "
                        >
                          <dynamic-html
                            v-if="
                              props.item[header.value] &&
                              typeof props.item[header.value].includes !=
                                'undefined' &&
                              props.item[header.value].includes('ui_')
                            "
                            :template="props.item[header.value]"
                            :skey="props.item[header.value]"
                            :key="props.item[header.value]"
                          />
                          <span v-else>{{ props.item[header.value] }}</span>
                        </td>
                      </template>
                      <td v-if="rowLevelMenu && rowLevelMenu.length">
                        <dynamic-menu
                          :mode="mode"
                          :chart="chart"
                          :item="props.item"
                          :menuList="rowLevelMenu"
                        />
                        <!-- <v-menu bottom left>
                          <template v-slot:activator="{ on }">
                            <v-btn color="blue" dark icon v-on="on">
                              <v-icon>more_vert</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-tile class="cursor-pointer" v-for="(menu) in rowLevelMenu" :key="menu.id" v-on:click="callMenuFunction(menu, props.item)">
                              <v-list-tile-title>{{ menu.name }}</v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu> -->
                      </td>
                      <td v-if="typeof props.item.attr_actions != 'undefined'">
                        <v-menu bottom left class="table-menu">
                          <template v-slot:activator="{ on }">
                            <v-btn color="blue" dark icon v-on="on">
                              <v-icon>more_vert</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-tile>
                              <v-list-tile-title
                                v-on:click="openPage(props.item.id)"
                                >Download File</v-list-tile-title
                              >
                            </v-list-tile>
                            <v-list-tile
                              v-if="typeof props.item.parent_id != 'undefined'"
                            >
                              <v-list-tile-title
                                v-on:click="openPage(props.item.parent_id)"
                                >Download Full File</v-list-tile-title
                              >
                            </v-list-tile>
                            <v-list-tile v-if="typeof props.item.attr_viewonly == 'undefined' && documentActionList.includes('convert-document')">
                              <v-list-tile-title
                                v-on:click="
                                  openConvertDocumentDialog(props.item)
                                "
                                >Convert Document</v-list-tile-title
                              >
                            </v-list-tile>
                            <v-list-tile>
                              <v-list-tile-title
                                v-on:click="
                                  openEmailDialog(props.item, false)
                                "
                                >Email File</v-list-tile-title
                              >
                            </v-list-tile>
                            <v-list-tile>
                              <v-list-tile-title
                                v-on:click="
                                  openEmailDialog(props.item, true)
                                "
                                >Email Full File</v-list-tile-title
                              >
                            </v-list-tile>
                            
                            
                            <v-list-tile v-if="typeof props.item.attr_viewonly == 'undefined'">
                              <v-list-tile-title
                                v-on:click="
                                  openSupervisorQueue(props.item)
                                "
                                >Add To Supervisor Queue</v-list-tile-title
                              >
                            </v-list-tile>
                            <!-- <v-list-tile>
                              <v-list-tile-title
                                v-on:click="indexDocument(props.item)"
                              >Index Document</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile>
                              <v-list-tile-title v-on:click="indexDocuments()">Index All Documents</v-list-tile-title>
                            </v-list-tile> -->

                            <!-- <v-list-tile>
                              <v-list-tile-title>Print File</v-list-tile-title>
                            </v-list-tile> -->
                            <v-list-tile v-if="typeof props.item.attr_viewonly == 'undefined' && documentActionList.includes('delete-document')">
                              <v-list-tile-title
                                v-on:click="openDeleteDocument(props.item)"
                                >Delete Document</v-list-tile-title
                              >
                            </v-list-tile>
                            <v-list-tile v-if="typeof props.item.attr_viewonly == 'undefined' && documentActionList.includes('delete-document')">
                              <v-list-tile-title
                                v-on:click="openDeletePage(props.item)"
                                >Delete Page</v-list-tile-title
                              >
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </td>
                    </tr>
                  </template>
                </v-data-table>

              </vue-perfect-scrollbar>
            </div>
          </div>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-layout
      fill-heights
      row
      wrap
      justify-center
      class="menu-row"
      v-else
      style="height: 100%; padding-top: 100px"
    >
    <v-progress-circular
      :size="70"
      :width="7"
      color="blue-grey"
      indeterminate
    ></v-progress-circular>
    </v-layout>

    <v-dialog v-model="convertDocumentDialog" persistent :hide-overlay="true">
      <v-card style="position: fixed; top: 100px; left: 20px; width: 550px">
        <v-card-title>
          <span class="headline">Convert Document</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap v-if="convertDocumentItem">
              <v-flex xs12>
                <v-select
                  :items="documentTypes"
                  :value="convertDocumentItem.document_type"
                  item-text="name"
                  item-value="code"
                  label="Select Document Type"
                  outline
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            @click="convertDocumentDialog = false"
            >Close</v-btn
          >
          <v-btn color="blue darken-1" flat @click="convertDocument()"
            >Convert</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ deleteProperties.title }}
        </v-card-title>

        <v-card-text>
          {{ deleteProperties.deleteMessage }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="deleteDialog = false">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            flat
            @click="deleteItem()"
            :loading="deleteProperties.loading"
          >
            {{ deleteProperties.buttonText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Email Dialog -->
    <v-dialog v-model="emailDialog" width="800">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Email Document
        </v-card-title>

        <v-card-text>
          <v-flex xs12>
            <v-text-field label="To" hint="You can add multiple emails separated by comma a (,)" v-model="emailProperties.to"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="Subject" v-model="emailProperties.subject"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-textarea label="Body" v-model="emailProperties.body"></v-textarea>
          </v-flex>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="emailDialog = false">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            flat
            @click="sendEmail()"
            :loading="emailProperties.loading"
          >
            Send 
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Supervisor Queue Dialog -->
    <v-dialog v-model="supervisorQueueDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Supervisor Queue
        </v-card-title>

        <v-card-text>
          Click Confirm To Add Document To Supervisor Queue
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="supervisorQueueDialog = false">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            flat
            @click="addToSupervisorQueue()"
            :loading="supervisorQueueProperties.loading"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const chartNamespace = createNamespacedHelpers("charts");
import {
  getDocumentUrl,
  getDocument,
  indexDocument,
  indexDocuments,
} from "@/models/awb";

const {
  mapState,
  mapActions,
  mapGetters,
  mapMutations,
} = createNamespacedHelpers("dataSources");

import UsersService from "@/services/users.service";
import ApiService from "@/services/api.service";

import VuePerfectScrollbar from "vue-perfect-scrollbar";
import draggable from "vuedraggable";
import DynamicHtml from "@/components/charts/text/dynamic-html/chart.vue";
import VRuntimeTemplate from "v-runtime-template";
import DynamicMenu from "@/components/charts/menu/chart.vue";

import { getAclMenuFromParameters, aclMenu } from "@/models/user.js";
// import numeral from 'numeral';

function formatNumber(num) {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

function convertToCSV(objArray) {
  var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
  var str = "";

  for (var i = 0; i < array.length; i++) {
    var line = "";
    for (var index in array[i]) {
      if (line != "") line += ",";

      line += array[i][index];
    }

    str += line + "\r\n";
  }

  return str;
}

function exportCSVFile(headers, input, fileTitle) {
  const items = [...input];
  if (headers) {
    items.unshift(headers);
  }

  // Convert Object to JSON
  var jsonObject = JSON.stringify(items);

  var csv = convertToCSV(jsonObject);
  //console.log('csv', csv);

  var exportedFilenmae = fileTitle + ".csv" || "export.csv";

  var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, exportedFilenmae);
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", exportedFilenmae);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}

function compareValues(key, order = "asc") {
  return function (a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
    const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order == "desc" ? comparison * -1 : comparison;
  };
}
const emailProperties = {
  to: "",
  subject: "",
  body: "See document attached.",
  loading: false
};

export default {
  props: ["chart", "mode"],
  data: function () {
    return {
      documentActionList: [],
      filteredData: [],
      dateFormatted: null,
      menu1: false,
      selectedItem: null,
      autoSelected: false,
      convertDocumentDialog: false,
      convertDocumentItem: null,
      deleteDialog: false,
      supervisorQueueDialog: false,
      emailDialog: false,
      emailItem: {},
      supervisorQueueProperties: {
        loading: false
      },
      emailProperties: {...emailProperties},
      deleteProperties: {
        item: null,
        message: "",
        loading: false,
        title: "",
        deleteButton: "",
      },
      documentTypes: [
        {
          code: "IMPORT_FLIGHTFILE",
          name: "IMPORT FLIGHT FILE",
          type: "document",
        },
        {
          code: "EXPORT_FLIGHTFILE",
          name: "EXPORT FLIGHT FILE",
          type: "document",
        },
        { code: "MAWB", name: "MAWB", type: "document" },
        { code: "COURIERFILE", name: "COURIERFILE FILE", type: "document" },
        { code: "RELEASENOTE", name: "RELEASE NOTE", type: "document" },
        {
          code: "BULK_RELEASENOTE",
          name: "BULK RELEASE NOTE",
          type: "document",
        },
        { code: "DSSFLIGHTFILE", name: "FLIGHT FILE", type: "file" },
        { code: "PODFILE", name: "POD FILE", type: "file" },
        { code: "COURIERFILE", name: "COURIER FILE", type: "file" },
      ],
      interval: null,
      search: "",
      styleRow: "",
      styleCell: "",
      rowLevelMenu: null,
      topButtonMenu: null,
      items: [
        {
          title: "Click Me",
        },
        {
          title: "Click Me",
        },
        {
          title: "Click Me",
        },
        {
          title: "Click Me 2",
        },
      ],
      menu: true,
      code: "/** INSERT SQL BELOW **/",
      columnsMenu: false,
      mergedTablesMenu: false,
      paginationCalls: 0,
      totalItems: 0,
      pagination: {
        rowsPerPageItems: [
          20,
          40,
          60,
          100,
          { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 },
        ],
        rowsPerPage: 10,
      },
      settings: {
        maxScrollbarLength: 60,
      },
      window: {
        width: 0,
        height: 0,
      },
    };
  },
  watch: {
    // totalItems: {
    //   handler() {
        
    //   }
    // },
    // pagination: {
    //   handler() {
    //     // this.paginate();
    //     console.log('handler ', this.pagination);
    //   },
    //   deep: true,
    // }
  },
  mounted() {
    // console.log("selectable table");
    // alert("selectable table");
    let that = this;
    this.setDocumentActionList();
    this.setTopButtonMenu();
    this.setRowLevelMenu();
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    
    if(this.chart) {
      this.chart.loadCompleted = function() {
        that.loadCompleted();
      }
    }
    
    // alert('mounted');

    // this.chart.afterLoad = function(params) {
    //   that.autoSelect();
    // }

    try {
      this.pagination.rowsPerPage = parseInt(this.chart.parameters.rowsPerPage.value);
    } catch (err) {
      console.log('cannot set rowsPerPage', err);
    }
    // console.log("this.pagination.rowsPerPage", this.pagination.rowsPerPage);
    // if(this.chart.parameters.rowsPerPage !)

    that.window.height = that.$refs.tableContainer.clientHeight - 100;
    that.autoSelect();
    this.interval = setInterval(function () {
      if (typeof that.$refs.tableContainer != "undefined") {
        //if(that.$refs.tableContainer.clientHeight != that.window.height) {
        that.window.height = that.$refs.tableContainer.clientHeight - 100;
        //}
      }
      that.autoSelect();

      // that.chart.chartData.options.height = that.height;
    }, 1000);
  },
  created() {
    // window.addEventListener('resize', this.handleResize)
    // this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {

    ...chartNamespace.mapMutations(["mSetSubChart"]),
    ...chartNamespace.mapActions(["aSetSubChart", "aUpdate", "aDelete", "aMerge", "aCreateMerge"]),
    customFilter(items, search, filter) {
      
      search = this.search.toString().toLowerCase();
      const results = items.filter(row => filter(row["type"], search));
      // console.log('results', results);
      return results;
    },
    uiFilter() {
        const word = this.search ? this.search.trim().toLowerCase() : '';
        if(!word) {
          this.filteredData = this.chart.dataSource.filteredData;
          return;
        }
        this.filteredData = this.chart.dataSource.filteredData.filter(item => {
          return Object.values(item).join(' ').toLowerCase().includes(word);
        });
    },
    loadCompleted() {
      try {
        if(!this.chart.chartData.pagination.serverSide) {
          this.uiFilter();
          // this.filteredData = [...this.chart.dataSource.filteredData];
          return;
        }
        this.filteredData = [...this.chart.dataSource.filteredData];
        this.totalItems = this.chart && this.chart.dataSource ? this.chart.dataSource.size : 0;
        
        //  this.pagination.totalItems = this.totalItems;
        console.log('loadCompleted this.totalItems', this.totalItems);
        console.log('loadCompleted this.pagination', this.pagination);
      } catch(error) {

      }
    },
    paginate(pagination) {
      // const pagination = this.pagination;
      this.paginationCalls++;
      if(this.paginationCalls <= 1) {
        return;
      }
      try {
        if(!this.chart.chartData.pagination.serverSide) {
          return;
        }
        this.chart.setRowsPerPage(parseInt(pagination.rowsPerPage));
        this.chart.setPage(parseInt(pagination.page));
        this.chart.setSort(pagination.sortBy, pagination.descending ? 'DESC' : 'ASC');
        this.chart.loadActiveItem();
        console.log('uiPagination', pagination);
      } catch(error) {
        console.log('paginate error', error);
      }
    },
    getMenu(key) {
      try {
        const rowLevelMenu = JSON.parse(this.chart.parameters[key].value);
        if (Array.isArray(rowLevelMenu) && rowLevelMenu.length) {
          return rowLevelMenu;
        }
      } catch (error) {
        //
      }
      return null;
    },
    setRowLevelMenu() {
      // this.rowLevelMenu = this.getMenu("rowLevelMenu");
      // console.log('this.chart.parameter', this.chart.parameters);
      this.rowLevelMenu = getAclMenuFromParameters(
        this.chart.parameters,
        "rowLevelMenu"
      );
      // getAclMenuFromParameters
    },
    setDocumentActionList() {
      const documentActionList = ['convert-document', 'delete-document', 'update-document'];
      this.documentActionList = aclMenu(documentActionList);
    },
    setTopButtonMenu() {
      // this.topButtonMenu = this.getMenu("topButtonMenu");
      this.topButtonMenu = getAclMenuFromParameters(
        this.chart.parameters,
        "topButtonMenu"
      );
    },
    callMenuFunction(params, item = null) {
      if (this.editable) {
        return;
      }
      if (!item) {
        item = {};
      }
      try {
        if (params.functionType == "openDashboard") {
          item.attr_popup = params.functionValue;
          this.setSubChart({ chart: this.chart, item: item, settings: params });
        }
      } catch (error) {}
    },
    autoSelect: function () {
      if (
        this.chart &&
        !this.chart.loading &&
        this.chart.dataSource &&
        this.chart.dataSource.filteredData &&
        this.chart.dataSource.filteredData.length &&
        !this.autoSelected
      ) {
        let newSelected = null;
        let newSelectedString = "";
        let key = null;
        if (typeof this.chart.dataSource.lastSubSelect == "undefined") {
          this.chart.dataSource.lastSubSelect = null;
        }
        if (this.chart.dataSource.filteredData.length != 1) {
          return;
        }
        const firstRow = this.chart.dataSource.filteredData[0];
        if (!key && typeof firstRow.id != "undefined") {
          key = "id";
        }
        if (!key && typeof firstRow.attr_data != "undefined") {
          key = "attr_data";
        }

        if (key && firstRow[key] != this.chart.dataSource.lastSubSelect) {
          this.chart.dataSource.lastSubSelect = firstRow[key];
          // alert("autoSelect");
          this.setSubChart({
            chart: this.chart,
            item: this.chart.dataSource.filteredData[0],
          });
          this.autoSelected = true;
          // this.selectedItem = this.chart.dataSource.filteredData[0];
        }
      }
    },
    openSupervisorQueue(item) {
      this.emailProperties = {};
      this.emailProperties.item = item;
      this.supervisorQueueDialog = true;
    },
    async addToSupervisorQueue() {
      this.supervisorQueueProperties.loading = true;
      try {
        const id = this.emailProperties.item.id;
        if (id) {
          await ApiService.query("/ocr/supervisor/queue/add/" + id);
          UsersService.trackEvent({
            model: "DOCUMENT",
            modelId: id,
            message: "Added to supervisor queue",
            reference: "ADDED_TO_SUPERVISOR_QUEUE",
            type: "ADDED_TO_SUPERVISOR_QUEUE",
          });
        }
      } catch (error) {
        console.log("email error", error);
      }

      this.supervisorQueueProperties.loading = false;
      this.supervisorQueueDialog = false;
    },
    openEmailDialog(item, parent) {
      this.emailProperties = {...emailProperties};
      this.emailProperties.parent = parent;
       this.emailProperties.item = item;
      if(typeof item.document_type != "undefined") {
        this.emailProperties.subject = item.document_type + " Document";
        this.emailProperties.body = item.document_type + " Attached";
       
      }

      if(parent) {
        this.emailProperties.subject = "File Attached";
        this.emailProperties.body = "See File Attached";
      }
      this.emailDialog = true;
    },
    async sendEmail() {
      this.emailProperties.loading = true;
      try {
        const id = this.emailProperties.item.id;
        if (id) {
          let url = "/ocr/email/document/" + id;
          if(this.emailProperties.parent) {
            url = "/ocr/email/document/full/" + id;
          }
          await ApiService.post(url, this.emailProperties);
          UsersService.trackEvent({
            model: "DOCUMENT",
            modelId: id,
            message: "Attachment Sent",
            reference: "EMAILED_ATTACHMENT",
            type: "EMAILED_ATTACHMENT",
          });
        }
      } catch (error) {
        console.log("email error", error);
      }

      this.emailProperties.loading = false;
      this.emailDialog = false;
    },


    openDeleteDocument(item) {
      this.deleteProperties = {
        endpoint: "/ocr/delete/document/",
        type: "DELETE_DOCUMENT",
        deleteMessage:
          "All pages in this document will be deleted. Click to proceed.",
        item: item,
        logMessage: "Document Deleted",
        loading: false,
        title: "Delete Document",
        buttonText: "Delete Document",
      };
      this.deleteDialog = true;
    },
    openDeletePage(item) {
      this.deleteProperties = {
        endpoint: "/ocr/delete/page/",
        type: "DELETE_PAGE",
        deleteMessage: "Click to delete page.",
        logMessage: "Page Deleted",
        item: item,
        loading: false,
        title: "Delete Page",
        buttonText: "Delete Page",
      };
      this.deleteDialog = true;
    },
    async deleteItem() {
      this.deleteProperties.loading = true;
      try {
        const id = this.deleteProperties.item.id;
        if (id) {
          await ApiService.query(this.deleteProperties.endpoint + id);
          UsersService.trackEvent({
            model: "DOCUMENT",
            modelId: this.deleteProperties.item.id,
            message: this.deleteProperties.logMessage,
            reference: this.deleteProperties.type,
            type: this.deleteProperties.type,
          });
        }
      } catch (error) {
        // console.log("delete error", error);
      }

      this.deleteProperties.loading = false;
      this.deleteDialog = false;
    },
    openConvertDocumentDialog(item) {
      this.convertDocumentDialog = true;
      this.convertDocumentItem = item;
    },
    setSubChart(params) {
      // alert("setSubChart");
      console.log("setSubChart params", params);
      this.selectedItem = params.item;
      this.aSetSubChart(params);
    },
    convertDocument() {
      this.convertDocumentDialog = false;
      this.chart.hydrate();
    },
    formSubmit() {
      // console.log("this.$refs", this.$refs);
      this.$refs.submitButton[0].$el.click();
    },
    searchQuery(item) {
      if (item && typeof item.search != "undefined" && item.search) {
        this.chart.hydrate();
      }
    },
    reset() {
      this.$refs.searchForm.reset();
      this.formSubmit();
    },
    format: function (val) {
      if (val && !isNaN(val)) {
        // return formatNumber(val.toFixed(2));
      }
      return val;
    },
    sort(header) {
      if (typeof header.sort == "undefined") {
        header.sort = "asc";
      } else {
        header.sort = header.sort == "asc" ? "desc" : "asc";
      }
      this.chart.dataSource.filteredData.sort(
        compareValues(header.value, header.sort)
      );
    },
    editorInit: function (editor) {},
    async openPage(id) {
      // alert(JSON.stringify(params));
      const data = await getDocumentUrl(id);
      const url = data.url;
      window.open(url, "_blank");
      // alert(JSON.stringify(data));
    },
    async indexDocument(params) {
      // alert(JSON.stringify(params));
      const data = await indexDocument(params.id);
      // const url = data.url;
      // window.open(url, '_blank');
      // alert(JSON.stringify(data));
    },
    async indexDocuments() {
      // alert(JSON.stringify(params));
      const data = await indexDocuments();
      // const url = data.url;
      // window.open(url, '_blank');
      // alert(JSON.stringify(data));
    },
    deSelect(items, i) {
      items[i].selected = false;
      items.splice(i, 1, items[i]);
      // console.log(items[i]);
    },
    select(items, i) {
      if (items[i].selected != true) {
        items[i].selected = true;
        items.splice(i, 1, items[i]);
      }
    },
    aggregate(items, i, fnc) {
      items[i].aggregate = fnc;
      items.splice(i, 1, items[i]);
    },
    download() {
      // console.log('this.chart', this.chart);
      this.chart.download();
      // let headers = Object.keys(items[0]);
      // exportCSVFile(headers, items, "export.csv");
    },
    toggleMenu(items, i) {
      items[i].menu = !items[i].menu;
      items.splice(i, 1, items[i]);
    },
    selectAll(items) {
      for (let i = 0; i < items.length; i++) {
        items[i].selected = true;
        items.splice(i, 1, items[i]);
      }
    },
    deSelectAll(items) {
      for (let i = 0; i < items.length; i++) {
        items[i].selected = false;
        items.splice(i, 1, items[i]);
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
      // this.window.height = window.innerHeight;
    },
  },
  computed: {
    ...mapState(["types", "dataSources", "dataSource", "allDataSources"]),
    ...chartNamespace.mapState({
      editable: (state) => state.editable
    }),
    computedHeaders() {
      // console.log('this.chart.subHeaders', this.chart.subHeaders);
      let computedHeaders = this.chart.subHeaders.filter(
        (h) => h.selected && !h.value.includes("attr_") && !h.value.includes("item__")
      ).map((item) => {
        if(item.value.startsWith("__")) {
          item.text = '';
        }
        return item;
      });
      const actions = this.chart.subHeaders.filter((h) =>
        h.value.includes("attr_actions")
      );
      if (actions.length) {
        computedHeaders.push({ text: "Actions", value: "" });
      }
      if (this.rowLevelMenu && this.rowLevelMenu.length) {
        computedHeaders.push({ text: " ", value: "" });
      }
      
      // computedHeaders.push({})
      // console.log("computedHeaders", computedHeaders);
      return computedHeaders;
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    try {
      clearInterval(this.interval);
      this.interval = null;
    } catch (err) {}
    // this.editor.destroy();
  },
  components: {
    "vue-perfect-scrollbar": VuePerfectScrollbar,
    draggable: draggable,
    "dynamic-html": DynamicHtml,
    "dynamic-menu": DynamicMenu,
  },
};
</script>
